var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"请选择","clearable":"","size":"mini"},on:{"change":_vm.selectChange},model:{value:(_vm.dictionary),callback:function ($$v) {_vm.dictionary=$$v},expression:"dictionary"}},_vm._l((_vm.dictionaryOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.text,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }